import { render } from "./PageSection.vue?vue&type=template&id=4823822e&scoped=true"
import script from "./PageSection.vue?vue&type=script&lang=js"
export * from "./PageSection.vue?vue&type=script&lang=js"

import "./PageSection.vue?vue&type=style&index=0&id=4823822e&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4823822e"]])

export default __exports__